import { Component, h, State, EventEmitter, Event } from '@stencil/core';
import { CHAT_CREDS, leOfferChatCreds } from '../constants/chat-creds';
import { isometrikLogo } from '../assets/svg/IsometrikLogo';

import { WEB_CONTENT } from '../constants/content.js';
import { Login_banner } from '../constants/chat-assets.js';
@Component({
  tag: 'login-page',
  shadow: true,
  styles: `
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100dvh;
      background: var(--bg-primary-color);
      font-family: 'Simpli Norm', sans-serif;
    }

    .login-container {
      padding: 2rem;
      border-radius: 10px;
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      background:var(--bg-secondary-color);
    }

    .login-header {
      text-align: center;
      color: var(--text-primary-color);
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .login-form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .form-group label {
      color: var(--text-primary-color);
      font-size: 12px;
    }

    .form-group input {
      padding: 0.75rem;
      border: 0.5px solid var(--bg-grey-color);
      border-radius: 10px;
      background: var(--bg-primary-color);
      color: var(--text-primary-color);
      outline: none;
    }

    .form-group input:focus {
      border-color: var(--base-color);
    }

    .login-button {
      background: var(--base-color);
      color: white;
      padding: 0.75rem;
      border: none;
      border-radius: 20px;
      cursor: pointer;
      font-weight: 500;
      transition: background-color 0.2s;
      width:30%;
      align-self:end;
    }
      .login-button:disabled{
      opacity:0.5;
      cursor:unset;
      }

    .error-message {
      color: var(--text-danger-color);
      font-size: 0.9rem;
      text-align: center;
      margin-top: 1rem;
    }

    .login-page-container {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      overflow: hidden;
    }
    .login-banner-container {
      background: var(--bg-primary-light);
      width: 50%;
      height: 100%;
      position: relative;
      padding: 20px;
      overflow: hidden;
    }

    .login-banner-logo {
      padding: 30px 20px;
    }

    .login-container-logo {
      padding: 30px 20px;
      position: absolute;
      top: 0;
      margin:auto;
      display: none;
    }


    .login-header h2 {
      font-size: 2rem;
      font-weight: 600;
      color: var(--text-primary-color);
      margin: 0;
    }

    .login-header p {
      font-size: 1rem;
      font-weight: 400;
      color: var(--text-primary-color);
      width: 80%;
      text-align: center;
    }
    .login-banner-text {
      padding: 20px;
      display:flex;
      align-items:center;
      flex-direction:column;
    }
    .login-banner-text h1 {
      font-size: 2.5rem;
      font-weight: 600;
      color: var(--base-color);
      width: 70%;
    }

    .login-banner-text p {
      font-size: 1.2rem;
      font-weight: 400;
      color: var(--text-primary-color);
      width: 70%;
      line-height: 1.4rem;
    }

   

    .login-image-overlay div {
      position: absolute;
      width: 187px;
      height: 187px;
      filter: blur(14px);
      border-radius: 50%;
       background: linear-gradient(225.81deg, #d8dffe 15.93%, #7a90f7 100%);
    
          
    }
       /* Style for WebKit browsers (Chrome, Safari, newer versions of Opera) */
      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
      -webkit-text-fill-color: var(--text-primary-color) !important;
      transition: background-color 5000s ease-in-out 0s;
      border: 0.5px solid var(--bg-grey-color);
      }

      input:autofill {
      background-color: var(--bg-primary-color) !important;
      color: var(--text-primary-color)  !important;
      border: 0.5px solid var(--bg-grey-color);
      }

      input:-internal-autofill-selected {
      background-color: var(--bg-primary-color) !important;
      color: var(--text-primary-color) !important;
      border: 0.5px solid var(--bg-grey-color);
      }

    .login-image-overlay div:first-child {
      top: -52px;
      right: -63px;
    }

    .login-container-inner {
    padding:15px;
    border-radius:25px;
    background: var(--bg-primary-color);
    box-shadow: 0px 10px 40px 0px var(--shadow-color);
    }

    .login-image-overlay div:nth-child(2) {
      bottom: -102px;
      left: -103px;
      height: 359px;
      width: 359px;
    }

    .login-footer {
      text-align: center;
      font-size: 14px;
    }

    .login-footer a {
      cursor: pointer;
      text-decoration: underline;

    }
    @media (max-width: 768px) {
   .login-banner-container {
     display: none;
   }

   .login-container {
    width: 100%;
    padding:1rem;
   }

   .login-container-logo {
    display: block;
   }
 }
  `,
})
export class Login {
  @State() username: string = '';
  @State() password: string = '';
  @State() errorMessage: string = '';
  @State() isLoading: boolean = false;

  @Event() loginSuccess: EventEmitter<string>;
  @Event() trySignup: EventEmitter<string>;

  private setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  private handleSubmit = async (e: Event) => {
    e.preventDefault();

    if (!this.username || !this.password) {
      this.errorMessage = 'Please fill in all fields';
      return;
    }

    try {
      this.isLoading = true;
      this.errorMessage = '';

      const response = await fetch(`${CHAT_CREDS.baseUrl}/chat/user/authenticate`, {
        method: 'POST',
        headers: {
          'accept': '*/*',
          'appsecret': `${leOfferChatCreds.appSecret}`,
          'content-type': 'application/json',
          'licenseKey': `${leOfferChatCreds.licenseKey}`,

          'sec-fetch-mode': 'cors',
          'sec-fetch-site': 'cross-site',
          'usersecret': `${leOfferChatCreds.userSecret}`,
        },

        // headers: {
        //   'accept': '*/*',
        //   'appsecret': `${kwibalChatCreds.appSecret}`,
        //   'content-type': 'application/json',
        //   'licenseKey': `${kwibalChatCreds.licenseKey}`,

        //   'sec-fetch-mode': 'cors',
        //   'sec-fetch-site': 'cross-site',
        //   'usersecret': `${kwibalChatCreds.userSecret}`,
        // },
        body: JSON.stringify({
          userIdentifier: this.username,
          password: this.password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      console.log('Login successful:', data);

      this.setCookie('userToken', data.userToken, 7);
      this.setCookie('isometrikUserId', data.userId, 7);
      this.loginSuccess.emit(data.userToken);

      const webChat = document.querySelector('web-chat');
      const loginPage = document.querySelector('login-page');

      if (webChat && loginPage) {
        webChat.style.display = 'block';
        loginPage.style.display = 'none';
      }

      window.location.reload();
    } catch (error) {
      console.error('Login failed:', error);
      this.errorMessage = 'Invalid username or password';
    } finally {
      this.isLoading = false;
    }
  };

  render() {
    return (
      <div class="login-page-container">
        <div class="login-banner-container">
          <div class="login-banner-logo" innerHTML={isometrikLogo}></div>
          <div class="login-banner-text">
            <h1>"Revolutionizing How You Chat."</h1>
            <p>"Welcome to the future of chatting – simple, fast, and inclusive. Start connecting like never before!"</p>
            <img src={Login_banner} alt="Login Page" style={{ width: '300px', height: '300px' }} />
          </div>
        </div>
        <div class="login-container">
          <div class="login-container-logo" innerHTML={isometrikLogo}></div>

          <div class="login-container-inner">
            <div class="login-header">
              <h2>{WEB_CONTENT.LOGIN}</h2>
              <p>{WEB_CONTENT.LOGIN_DESC}</p>
            </div>

            <form class="login-form" onSubmit={this.handleSubmit}>
              <div class="form-group">
                <label htmlFor="username">{WEB_CONTENT.EMAIL}</label>
                <input
                  type="email"
                  id="username"
                  value={this.username}
                  onInput={(e: Event) => (this.username = (e.target as HTMLInputElement).value)}
                  placeholder={WEB_CONTENT.EMAIL}
                />
              </div>

              <div class="form-group">
                <label htmlFor="password">{WEB_CONTENT.PASSWORD}</label>
                <input
                  type="password"
                  id="password"
                  value={this.password}
                  onInput={(e: Event) => (this.password = (e.target as HTMLInputElement).value)}
                  placeholder={WEB_CONTENT.PASSWORD}
                />
              </div>

              {this.errorMessage && <div class="error-message">{this.errorMessage}</div>}

              <button type="submit" class="login-button" disabled={!this.username || !this.password || this.isLoading}>
                {this.isLoading ? 'Logging in...' : 'Log In'}
              </button>
            </form>
          </div>
          {/* <div class="login-footer">
            New here? <a onClick={() => this.trySignup.emit()}>Try Signing Up</a>
          </div> */}
        </div>
      </div>
    );
  }
}
